<template lang="html">

  <section class="ficha -observaciones">

    <h2 class="ficha-title" :style="styles.colorBasic">Observaciones</h2>

    <template v-for="(observacion, key) in observaciones" v-if="observaciones.length > 0">
      <observacion-el :data="observacion"></observacion-el>
    </template>

    <template v-if="observaciones.length == 0">
      <p>Esta práctica no contiene observaciones</p>
    </template>

    <template v-for="(observacion, key) in observacionespractica" v-if="observaciones.length > 0">
      <observacion-el :data="observacion"></observacion-el>
    </template>

    <h2 v-if="showadd" class="ficha-title" :style="styles.colorBasic">Nueva Observación</h2>

    <nueva-observacion v-if="showadd && brand.canUploadObservaciones" @refresh="refresh" @cancel="showadd = false"></nueva-observacion>

    <div class="contenedor-botones row-start" v-if="!showadd">
      <a class="btn" :style="styles.solidPrimary" @click="showadd = true">Añadir observación</a>
    </div>





  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import observacion from '@/components/parts/observacion-el';
  import nuevaobservacion from '@/components/parts/nueva-observacion';


  export default {
    name: 'ficha-observaciones',
    props: ['observaciones', 'observacionespractica'],
    data() {
      return {
        documentacion: [],
        showadd: false
      }
    },
    mounted() {

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        brand : 'getBrand'
      })
    },
    methods: {
      ...mapActions(['dameContestacionEncuesta']),
      refresh(){
        this.$emit('refresh');
        this.showadd = false;
      }
    },
    components: {
      'observacion-el': observacion,
      'nueva-observacion': nuevaobservacion
    }
  }
</script>

<style scoped lang="scss">
  .ficha.-observaciones {
    .ficha-title {
      margin-top: 5px;

      &.-documentacion-practica {
        margin-top: 20px;
      }
    }

    p {
      text-align: left;
      width: 100%;
      display: inline-block;
      font-size: 14px;
    }

    .add-documentacion {
      cursor: pointer;
      margin-top: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-observaciones.vue